module.exports = __webpack_public_path__ + "acce6af544717a8650f744b944d508c4.webp";